import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import addMonths from 'date-fns/addMonths';

const nextMonth = addMonths(new Date(), 1);

type UsePreserveLastSelectedMonthParams = {
  defaultMonth?: Date;
  selectedDate?: Date;
  isDayPickerOpen: boolean;
};

export const useControlledMonth = ({
  defaultMonth,
  isDayPickerOpen,
  selectedDate,
}: UsePreserveLastSelectedMonthParams): [Date, Dispatch<SetStateAction<Date>>] => {
  /** Used to open last selected day month */
  const [month, setMonth] = useState<Date>(defaultMonth || nextMonth);

  useEffect(() => {
    /** If day is selected open month in which this day is selected */
    if (isDayPickerOpen && selectedDate) {
      setMonth(selectedDate);
    } else setMonth(new Date());
  }, [selectedDate, isDayPickerOpen]);

  return [month, setMonth];
};
